import { render, staticRenderFns } from "./FmContact.vue?vue&type=template&id=d0d9aeb4"
import script from "./FmContact.vue?vue&type=script&lang=ts"
export * from "./FmContact.vue?vue&type=script&lang=ts"
import style0 from "./FmContact.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,RichText: require('/app/components/base/RichText/RichText.vue').default,ButtonComponent: require('/app/components/base/ButtonComponent/ButtonComponent.vue').default})
